import React, { Component } from "react"
import styled from "styled-components"
import { reduxForm, Field } from "redux-form"
import Container from "container/Academy"
import Select from 'react-select';
import {
  Route, Switch, Link,
} from "react-router-dom"
import colors from "../../../lib/colors"

const required = value => value ? undefined : "* Required"

const EventForm = styled.form`
 label {
  font-family: "SF Pro Display", sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #24292e;
  .required {
   color: red;
  }
 }
`
const UpperDiv = styled.div`
  width: 100%;
  height: 350px;
  display: flex;
`

const LowerDiv = styled.div`
  width: 100%;
  height: 350px;
  padding: 50px;
  button {
   float: right;
   position: relative;
   top: 207px;
  }
`

const InfoDiv = styled.div`
  width: 250px;
  height: 350px;
  flex-grow: 3;
  padding: 46px;
`


const PhotoDiv = styled.div`
  height: 100%;
  max-width: 250px;
  flex-grow:2;
`

const InputFields = styled(Field)`
  width: 100%;
  height: 39px;
  border-radius: 3px;
  border: solid 1px #d1d5da;
  background-color: #fafbfc;
  margin-bottom: 37px;
  padding-left: 9px;
`
class AddEventForm extends React.Component {

 componentDidMount() {
  const {
   eventDetail,
   isUpdateMode,
   initialize,
  } = this.props

  if(isUpdateMode
  && eventDetail
  && Object.keys(eventDetail).length > 0) {
    initialize({
     eventName: eventDetail.title,
     eventShortDescription: eventDetail.non_rtf_description,
     eventSource: eventDetail.event_source,
    })
  }
 }

 render() {
  const {
    handleSubmit,
   } = this.props

  return (
    <EventForm id='event-form' onSubmit={handleSubmit}>
      <div className="eventname">
        <label htmlFor="Event Name">
         Event Name
         <span className="required">*</span>
        </label>
        <InputFields name="eventName" component="input" type="text" />
      </div>
      <div className="eventSource">
        <label htmlFor="Event Source">
         Event Source
         <span className="required">*</span>
        </label>
        <InputFields name="eventSource" component="input" type="text" />
      </div>
      <div className="eventShortDescription">
        <label htmlFor="Event Description for Community (Short)">
         Event Community Description
         <span className="required">*</span>
        </label>
        <InputFields name="eventShortDescription" component="input" type="text" />
      </div>
    </EventForm>
  )
 }
}

AddEventForm = reduxForm({
  form: 'addEventsForm',
  destroyOnUnmount: false,
})(AddEventForm)

export default AddEventForm
